
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Cart() {
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'طماطم طازجة - كيلو',
      price: 12,
      quantity: 2,
      image: 'https://public.readdy.ai/ai/img_res/2df58ac7c9e3de7576e23b0bbb16a4f4.jpg',
      color: 'أحمر',
      size: 'كبير'
    },
    {
      id: 2,
      name: 'حليب طازج - لتر',
      price: 15,
      quantity: 1,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%20dairy%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20white%20and%20blue%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=200&height=200&seq=cartgro2&orientation=squarish',
      color: 'أبيض',
      size: 'لتر'
    },
    {
      id: 3,
      name: 'خبز طازج',
      price: 8,
      quantity: 1,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20loaf%20bakery%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20golden%20brown%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=200&height=200&seq=cartgro3&orientation=squarish',
      color: 'ذهبي',
      size: 'متوسط'
    }
  ]);

  const [promoCode, setPromoCode] = useState('');
  const [appliedPromo, setAppliedPromo] = useState(false);

  const updateQuantity = (id: number, newQuantity: number) => {
    if (newQuantity < 1) return;
    setCartItems(cartItems.map(item => 
      item.id === id ? { ...item, quantity: newQuantity } : item
    ));
  };

  const removeItem = (id: number) => {
    setCartItems(cartItems.filter(item => item.id !== id));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 10;
  const discount = appliedPromo ? 5 : 0;
  const total = subtotal + shipping - discount;

  const applyPromo = () => {
    if (promoCode.trim()) {
      setAppliedPromo(true);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-32" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h2 className="text-lg font-bold text-gray-800">سلة التسوق</h2>
          <div className="w-10"></div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 px-4">
        {cartItems.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-32 h-32 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shopping-cart-line text-6xl text-blue-500"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">سلة التسوق فارغة</h3>
            <p className="text-gray-600 mb-6">ابدأ بإضافة منتجات إلى سلتك</p>
            <Link
              to="/"
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold shadow-lg"
            >
              تصفح المنتجات
            </Link>
          </div>
        ) : (
          <>
            {/* Cart Items */}
            <div className="mb-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4">المنتجات ({cartItems.length})</h3>
              <div className="space-y-4">
                {cartItems.map((item) => (
                  <div key={item.id} className="bg-white rounded-2xl p-4 shadow-sm">
                    <div className="flex gap-4">
                      <div className="w-24 h-24 bg-gray-100 rounded-xl overflow-hidden flex-shrink-0">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="flex-1">
                        <div className="flex items-start justify-between mb-2">
                          <h4 className="text-sm font-bold text-gray-800 line-clamp-2">{item.name}</h4>
                          <button
                            onClick={() => removeItem(item.id)}
                            className="w-8 h-8 flex items-center justify-center text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <i className="ri-delete-bin-line text-lg"></i>
                          </button>
                        </div>
                        <div className="flex items-center gap-2 mb-2 text-xs text-gray-600">
                          <span>اللون: {item.color}</span>
                          <span>•</span>
                          <span>الحجم: {item.size}</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                            {item.price} ر.س
                          </span>
                          <div className="flex items-center gap-3">
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                              className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors"
                            >
                              <i className="ri-subtract-line text-gray-700"></i>
                            </button>
                            <span className="text-sm font-bold text-gray-800 w-6 text-center">{item.quantity}</span>
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                              className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center shadow-md"
                            >
                              <i className="ri-add-line text-white"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Promo Code */}
            <div className="mb-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4">كود الخصم</h3>
              <div className="flex gap-3">
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="أدخل كود الخصم"
                  className="flex-1 px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={appliedPromo}
                />
                <button
                  onClick={applyPromo}
                  disabled={appliedPromo}
                  className={`px-6 py-3 rounded-xl font-bold text-sm transition-all duration-300 ${
                    appliedPromo
                      ? 'bg-green-500 text-white'
                      : 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                  }`}
                >
                  {appliedPromo ? <i className="ri-check-line text-xl"></i> : 'تطبيق'}
                </button>
              </div>
              {appliedPromo && (
                <p className="text-sm text-green-600 mt-2 flex items-center gap-1">
                  <i className="ri-checkbox-circle-fill"></i>
                  تم تطبيق كود الخصم بنجاح!
                </p>
              )}
            </div>

            {/* Order Summary */}
            <div className="bg-white rounded-2xl p-6 shadow-sm mb-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4">ملخص الطلب</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between text-gray-600">
                  <span>المجموع الفرعي</span>
                  <span className="font-bold">{subtotal} ر.س</span>
                </div>
                <div className="flex items-center justify-between text-gray-600">
                  <span>الشحن</span>
                  <span className="font-bold">{shipping} ر.س</span>
                </div>
                {discount > 0 && (
                  <div className="flex items-center justify-between text-green-600">
                    <span>الخصم</span>
                    <span className="font-bold">-{discount} ر.س</span>
                  </div>
                )}
                <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
                  <span className="text-lg font-bold text-gray-800">المجموع الكلي</span>
                  <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {total} ر.س
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Bottom Bar */}
      {cartItems.length > 0 && (
        <div className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 px-4 py-4 z-50">
          <Link
            to="/checkout"
            className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
          >
            <span>إتمام الطلب</span>
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      )}
    </div>
  );
}
